import { createAction } from '@reduxjs/toolkit';
import * as ActionTypes from '../../constants/VisitorActionTypes';
import { trackInteraction } from '../../usage-tracking/actions/trackInteraction';
export const clickedMeetingsLinkAction = createAction(ActionTypes.CLICKED_MEETINGS_LINK);
export function clickedMeetingsLink() {
  return dispatch => {
    dispatch(clickedMeetingsLinkAction());
    dispatch(trackInteraction('widget-interaction', {
      action: 'clicked meeting link'
    }));
  };
}